module.exports = "<div class=\"gw-control-group\">\r\n    <label class=\"gw-control-label\">Please select a payment date</label>\r\n\r\n    <div class=\"gw-controls\">\r\n        <select ng-model=\"valueSelected.value\"\r\n            ng-options=\"item for item in selectDateList\">\r\n        </select>\r\n    </div>\r\n</div>\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policyjob/directives/templates/payment-date.html
 ** module id = 509
 ** module chunks = 0
 **/